/**
 * Docs from
 * https://primeng.org/multiselect
 */
export const multiselect = {
  css: ({ dt }: { dt: any }) => `
    .p-multiselect-option.p-multiselect-option-selected.p-focus {
      background: ${dt('surface.0')};
      color: ${dt('surface.950')};
    }
    .p-multiselect-option.p-multiselect-option-selected {
      background: ${dt('surface.0')};
      color: ${dt('surface.950')};
    }
  `,
};
